import { motion } from "framer-motion";
import { B } from "../data/pillars";

export default function EdgeCheckCTA({ intake, avgScore }) {
  const items = [
    { icon: "🔍", label: "Live Network Scan", desc: "Active device discovery, open ports, and shadow IT identification" },
    { icon: "💰", label: "True Cost Baseline", desc: "Actual IT spend mapped to headcount — break-fix, licenses, hidden waste" },
    { icon: "⚠️", label: "Breach Cost Modeling", desc: "Actuarial-style exposure scoped to your industry, size, and control gaps" },
    { icon: "📋", label: "Formal Budget Proposal", desc: "12-month technology roadmap with itemized investment and ROI model" },
  ];

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      style={{
        background: `linear-gradient(135deg, #1A2E4A, #0D1B2E)`,
        borderRadius: 16,
        border: `2px solid ${B.blue}60`,
        padding: "clamp(24px,5vw,40px)",
        marginBottom: 24,
        boxSizing: "border-box",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 8, flexWrap: "wrap" }}>
        <div style={{ background: B.blue, color: B.white, fontWeight: 800, fontSize: 11, padding: "4px 12px", borderRadius: 5, letterSpacing: 1 }}>
          NEXT STEP
        </div>
      </div>

      <h2 style={{ fontSize: "clamp(22px,4vw,32px)", fontWeight: 900, color: B.white, margin: "0 0 8px", lineHeight: 1.2 }}>
        EdgeCheck Technical Audit
      </h2>
      <p style={{ color: B.lightGray, fontSize: 15, lineHeight: 1.7, maxWidth: 620, margin: "0 0 28px" }}>
        This assessment identifies <em>where</em> the gaps are. The <strong style={{ color: B.accent }}>EdgeCheck Audit</strong> quantifies exactly what they cost — with live network data, real spend analysis, and a formal financial model you can take to leadership.
      </p>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(240px,1fr))", gap: 14, marginBottom: 28 }}>
        {items.map(item => (
          <div key={item.label} style={{ background: "#122240", borderRadius: 10, padding: "16px 18px", border: "1px solid #1E3A5F", display: "flex", gap: 12, alignItems: "flex-start" }}>
            <div style={{ fontSize: 22, flexShrink: 0 }}>{item.icon}</div>
            <div>
              <div style={{ color: B.white, fontWeight: 700, fontSize: 13, marginBottom: 4 }}>{item.label}</div>
              <div style={{ color: B.subText, fontSize: 12, lineHeight: 1.5 }}>{item.desc}</div>
            </div>
          </div>
        ))}
      </div>

      <div style={{ display: "flex", gap: 14, flexWrap: "wrap", alignItems: "center" }}>
        <a
          href="https://www.visualedgeit.com"
          target="_blank"
          rel="noreferrer"
          style={{
            background: `linear-gradient(135deg, ${B.blue}, ${B.darkBlue})`,
            border: "none", borderRadius: 10, padding: "14px 30px",
            color: B.white, fontSize: 14, fontWeight: 800, textDecoration: "none",
            letterSpacing: 0.5, display: "inline-block",
          }}
        >
          Schedule My EdgeCheck Audit →
        </a>
        <button
          onClick={() => window.print()}
          style={{
            background: "none", border: "1px solid #1E3A5F", borderRadius: 10,
            padding: "14px 24px", color: B.subText, fontSize: 13, fontWeight: 700,
            cursor: "pointer", letterSpacing: 0.5,
          }}
        >
          ↓ Export This Report
        </button>
      </div>

      {intake.rep && (
        <div style={{ marginTop: 20, color: B.subText, fontSize: 12 }}>
          Prepared by <strong style={{ color: B.lightGray }}>{intake.rep}</strong> · {new Date().toLocaleDateString()}
        </div>
      )}
    </motion.div>
  );
}